import { post } from '@eika-infrastruktur/request';

import { getRequestOptions } from '../meldskade/reducer/skademelding-actions';
import { Skademeldingstype } from '../types/generated-types';
import { loggErrorUrl, loggInfoUrl, loggWarnUrl } from '../urler';

const EIKA_BANK_REGNR = '0770';

class Logg {
    errorUrl: string;

    warnUrl: string;

    infoUrl: string;

    requestOptions: any;

    constructor(bankregnr: string) {
        this.errorUrl = loggErrorUrl();
        this.warnUrl = loggWarnUrl();
        this.infoUrl = loggInfoUrl();
        this.requestOptions = getRequestOptions(bankregnr);
    }

    private async post(
        url: string,
        message: string,
        error: Error,
        userId = 'Ingen Kundeidentifikator',
        skademeldingstype: Skademeldingstype = null,
    ): Promise<void> {
        await post(
            url,
            {
                data: {
                    error: error ? JSON.stringify(error, Object.getOwnPropertyNames(error)) : '',
                    userAgent: navigator.userAgent,
                    userId,
                    skadetype: skademeldingstype,
                },
                message,
            },
            this.requestOptions,
        ).then();
    }

    async info(message: string, userId?: string, skadeType?: Skademeldingstype, error: Error = null) {
        await this.post(this.infoUrl, message, error, userId, skadeType);
    }

    async warn(message: string, userId?: string, skadeType?: Skademeldingstype, error: Error = null) {
        await this.post(this.warnUrl, message, error, userId, skadeType);
    }

    async error(message: string, userId?: string, skadeType?: Skademeldingstype, error: Error = null) {
        await this.post(this.errorUrl, message, error, userId, skadeType);
    }
}

export const logger = (bankregnr = EIKA_BANK_REGNR): Logg => new Logg(bankregnr);
